import { Control } from "./control";

export class Html extends Control {
    public html: string = "";

    public getComponentName(): string {
        return "HtmlComponent";
    }
}
